export const DEFAULT_TOAST_TTL = 5000;

export const TOAST_HEADER_ICON_SIZE = 16;
